<template>
  <div class="login-page">
    <div class="login-card">
      <Icon class="icon" style="font-size: 120px; color: #0078d4; margin-bottom: 1rem;" icon="mdi:access-point-network" />
      <h1>Bem-vindo</h1>
      <p>Escolha sua forma de login.</p>
      <button @click="login" class="btn-microsoft">
        <Icon icon="mdi:microsoft" style="font-size: 24px; margin-right: 8px; vertical-align: middle;" />
        Logar com a Microsoft
      </button>
    </div>
  </div>
</template>
<script>
import { authService } from '@/services/backend/authService';
import { Icon } from '@iconify/vue';

export default {
  components: {
    Icon
  },
  methods: {
    login() {
      authService.login()
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.login-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
  padding: 48px 36px 36px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 340px;
}

.icon {
  margin-bottom: 1rem;
}

h1 {
  font-size: 2.2rem;
  margin-bottom: 0.5rem;
  color: #22223b;
  font-weight: 700;
}

p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  color: #4a4e69;
}

.btn-microsoft {
  display: flex;
  align-items: center;
  background-color: #0078d4;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 28px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
}

.btn-microsoft:hover {
  background-color: #005fa3;
}

.btn-first-access{
  margin-top: 1em;
  color: #0078d4;
  font-size: 1.3em;
  cursor: pointer;
}

</style>
